import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useToastHandler } from "@/hooks/useToastHandler";
import { authApi } from "@/api/authApi";
import { Button } from "@/components/ui/button";
import PageTitleScript from "@/components/MetaScript";

/**
 * This component is for local development only.
 * It allows automatic login with admin credentials.
 * DO NOT USE IN PRODUCTION!
 */
export function PasswordLogin() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { handleSuccess, handleError, clearToasts } = useToastHandler();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setIsLoading(true);
    clearToasts();

    try {
      await authApi.passwordLogin(userEmail, userPassword);
      // Redirect to the dashboard
      setTimeout(() => {
        //handleSuccess("Login successful");
      }, 300);
      navigate("/track", { replace: true });
    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <main className="flex flex-col items-center justify-center min-h-screen p-4 md:p-8bg-bg-light">
      <PageTitleScript title="Login" />
      <div className="bg-white p-6 md:p-10 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-3xl font-extrabold mb-4  text-tx-dark">
          User Login
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="userEmail"
              className="block text-sm font-medium mb-1"
            >
              Email
            </label>
            <input
              id="userEmail"
              type="email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-sm"
              placeholder="Enter user email"
              required
            />
          </div>

          <div>
            <label
              htmlFor="userPassword"
              className="block text-sm font-medium mb-1"
            >
              Password
            </label>
            <input
              id="userPassword"
              type="password"
              value={userPassword}
              onChange={(e) => setUserPassword(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-sm"
              placeholder="Enter password"
              required
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            size="lg"
            className="w-full py-2 px-4 rounded-md"
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Login"}
          </Button>

          <div className="mt-4 text-center">
            <Button
              variant="link"
              className="text-sm"
              type="button"
              onClick={() => navigate("/login")}
            >
              Regular Login
            </Button>
          </div>
        </form>
      </div>
    </main>
  );
}
